<template>
  <base-container>
    <view class="cube-dialog-list-item" wx:if="{{ isPassenger }}">
      <cube-dialog-alert></cube-dialog-alert>
    </view>
    <view class="cube-dialog-list-item" wx:if="{{ isPassenger }}">
      <cube-dialog-confirm></cube-dialog-confirm>
    </view>
    <view class="cube-dialog-list-item" wx:if="{{ isDriver }}">
      <cube-dialog-alert-with-inner-icon></cube-dialog-alert-with-inner-icon>
    </view>
    <view class="cube-dialog-list-item" wx:if="{{ isDriver }}">
      <cube-dialog-confirm-with-inner-icon></cube-dialog-confirm-with-inner-icon>
    </view>
    <view class="cube-dialog-list-item" wx:if="{{ isPassenger }}">
      <cube-dialog-with-head-icon></cube-dialog-with-head-icon>
    </view>
    <view class="cube-dialog-list-item" wx:if="{{ isDriver }}">
      <cube-dialog-show-close></cube-dialog-show-close>
    </view>
    <view class="cube-dialog-list-item" wx:if="{{ isDriver }}">
      <cube-dialog-show-slot></cube-dialog-show-slot>
    </view>
    <!-- <view class="cube-dialog-list-item" wx:if="{{ isPassenger }}">
      <cube-dialog-show-slot-with-right-angle></cube-dialog-show-slot-with-right-angle>
    </view> -->
    <view class="cube-dialog-list-item" wx:if="{{ isDriver }}">
      <cube-dialog-btn-slot></cube-dialog-btn-slot>
    </view>
    <view class="cube-dialog-list-item" wx:if="{{ isPassenger }}">
      <cube-dialog-btn-vertical></cube-dialog-btn-vertical>
    </view>
  </base-container>
</template>

<script>
import { createPage } from '@mpxjs/core'
import { useTheme } from '../../common/theme'

createPage({
  setup() {
    const { isDriver, isPassenger } = useTheme()
    return {
      isDriver,
      isPassenger
    }
  }
})
</script>

<style lang="stylus">
  .cube-dialog-list-item
    margin-bottom 20px
</style>

<script type="application/json">
  {
    "usingComponents": {
      "base-container": "../../components/base-container",
      "cube-dialog-alert": "./dialog-alert.mpx",
      "cube-dialog-confirm": "./dialog-confirm.mpx",
      "cube-dialog-alert-with-inner-icon": "./dialog-alert-with-inner-icon",
      "cube-dialog-with-head-icon": "./dialog-head-icon",
      "cube-dialog-prompt": "./dialog-prompt",
      "cube-dialog-confirm-with-inner-icon": "./dialog-confirm-with-inner-icon",
      "cube-dialog-btn-vertical": "./dialog-btn-vertical",
      "cube-dialog-btn-slot": "./dialog-btn-slot",
      "cube-dialog-show-close": "./dialog-show-close",
      "cube-dialog-show-slot": "./dialog-show-slot",
      "cube-dialog-show-slot-with-right-angle": "./dialog-show-slot-with-right-angle"
    }
  }
</script>
